<script setup>
import { ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';
import dayjs from 'dayjs';

const props = defineProps({
    expireTimestamp: {
        type: Number,
    },
});

const timeLeft = ref('');

function updateTimeLeft() {
    const now = dayjs();
    const expiry = dayjs.unix(props.expireTimestamp);
    const diff = expiry.diff(now);

    if (diff <= 0) {
        timeLeft.value = '00:00';
        // eslint-disable-next-line no-use-before-define
        if (pause) pause();
        return;
    }

    const duration = dayjs.duration(diff);
    timeLeft.value = duration.format('mm:ss');
}

const { pause } = useIntervalFn(updateTimeLeft, 1000, { immediate: true, immediateCallback: true });
</script>

<template>
    <span>{{ timeLeft }}</span>
</template>
